import { render, staticRenderFns } from "./StaticInfoForm.vue?vue&type=template&id=575838b4&scoped=true"
import script from "./StaticInfoForm.vue?vue&type=script&lang=js"
export * from "./StaticInfoForm.vue?vue&type=script&lang=js"
import style0 from "./StaticInfoForm.vue?vue&type=style&index=0&id=575838b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575838b4",
  null
  
)

export default component.exports